module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-12-19 at 20.18.59.41ec49a6.jpeg";